import { render, staticRenderFns } from "./ProjectbomChange.vue?vue&type=template&id=13ebe5df&scoped=true&"
import script from "./ProjectbomChange.vue?vue&type=script&lang=js&"
export * from "./ProjectbomChange.vue?vue&type=script&lang=js&"
import style0 from "./ProjectbomChange.vue?vue&type=style&index=0&id=13ebe5df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebe5df",
  null
  
)

export default component.exports